import { useState, useEffect, useCallback } from 'react';
import * as fileApi from '../../views/administracion/GestorDeArchivos/integracion';
import useGetDataUser from './useGetDataUser';

export const useFileManager = () => {
    const dataUser = useGetDataUser()
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPath, setCurrentPath] = useState('');

    const fetchFiles = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await fileApi.getFiles(currentPath);
            setFiles(data);
        } catch (err) {
            console.error('Error al obtener archivos:', err);
            // Captura errores generales de la API aquí, por ejemplo, si el servidor está caído
            const errorMessage = err.response?.data?.message || err.message || 'Error desconocido al cargar los archivos.';
            setError({ message: errorMessage }); // Establece un objeto de error para el estado 'error'
        } finally {
            setLoading(false);
        }
    }, [currentPath]);

    useEffect(() => {
        fetchFiles();
    }, [fetchFiles]);
    
    const handleCreateFile = async (file) => {
        try {
            await fileApi.createFile(file, currentPath,dataUser.user.ID);
            fetchFiles();
            return { success: true, message: 'Archivo subido con éxito.' };
        } catch (err) {
            console.error('Error al subir archivo:', err);
            const errorMessage = err.response?.data?.message || 'Error desconocido al subir el archivo.';
            return { success: false, message: errorMessage };
        }
    };

    const handleCreateFolder = async (folderName) => {
        try {
            await fileApi.createFolder(folderName, currentPath,dataUser.user.ID);
            fetchFiles();
            return { success: true, message: 'Carpeta creada con éxito.' };
        } catch (err) {
            console.error('Error al crear carpeta:', err);
            const errorMessage = err.response?.data?.message || 'Error desconocido al crear la carpeta.';
            return { success: false, message: errorMessage };
        }
    };

    const handleRenameItem = async (oldName, newName) => {
        try {
            await fileApi.renameItem(oldName, newName, currentPath,dataUser.user.ID);
            fetchFiles();
            return { success: true, message: 'Elemento renombrado con éxito.' };
        } catch (err) {
            console.error('Error al renombrar elemento:', err);
            const errorMessage = err.response?.data?.message || 'Error desconocido al renombrar el elemento.';
            return { success: false, message: errorMessage };
        }
    };

    const handleDeleteItem = async (itemName) => {
        try {
            await fileApi.deleteItem(itemName, currentPath,dataUser.user.ID);
            fetchFiles();
            return { success: true, message: 'Elemento eliminado con éxito.' };
        } catch (err) {
            console.error('Error al eliminar elemento:', err);
            const errorMessage = err.response?.data?.message || 'Error desconocido al eliminar el elemento.';
            return { success: false, message: errorMessage };
        }
    };

    const navigateToFolder = useCallback((folderPath) => {
        setCurrentPath(folderPath);
    }, []);

    return {
        files,
        loading,
        error,
        currentPath,
        fetchFiles,
        handleCreateFile,
        handleCreateFolder,
        handleRenameItem,
        handleDeleteItem,
        navigateToFolder
    };
};